import { render, staticRenderFns } from "./SkillsWorkflowSelector.vue?vue&type=template&id=1d3d1bed&scoped=true&"
import script from "./SkillsWorkflowSelector.vue?vue&type=script&lang=js&"
export * from "./SkillsWorkflowSelector.vue?vue&type=script&lang=js&"
import style0 from "./SkillsWorkflowSelector.vue?vue&type=style&index=0&id=1d3d1bed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3d1bed",
  null
  
)

export default component.exports